import interpolateComponents from 'interpolate-components';
import { useContext } from 'react';
import { useStores } from 'src/common/providers';
import { HELP_CHROME80 } from '../../constants/cmsLinks';
import {
  POP_OUT_DIALOG_MESSAGE_LINK,
  POP_OUT_DIALOG_MESSAGE_V2,
} from '../../constants/localizations/player';
import { LocationAndLocalizationContext } from '../../providers/LocationAndLocalizationProvider';
import PopOutButton from '../shared/button/PopOutButton';
import CommonDialog from '../shared/dialog/CommonDialog';
import UnderlineLink from '../shared/link/UnderlineLink';
import css from './popout-player-dialog.module.scss';

const buttonDimensions = {
  width: '45',
  height: '45',
};

export function PopoutPlayerDialog() {
  const { getLocalizedText } = useContext(LocationAndLocalizationContext);
  const { playerStore } = useStores();
  const setPopoutState = playerStore.setPopoutState();
  const isDialogOpen = playerStore.popout()?.isDialogOpen;

  if (!isDialogOpen) {
    return null;
  }

  function closeDialog() {
    setPopoutState({ isDialogOpen: false });
  }

  return (
    <CommonDialog
      modal
      dialogOpen
      handleDialogClose={closeDialog}
      contentStyle={{
        maxWidth: 510,
        overflow: 'hidden',
      }}
    >
      <h2 className={css.messageContainer} data-testid="messageContainer">
        {interpolateComponents({
          mixedString: getLocalizedText(POP_OUT_DIALOG_MESSAGE_V2),
          components: {
            helplink: (
              <UnderlineLink
                data-testid="helpLink"
                to={HELP_CHROME80}
                target="_blank"
                isNotReactRouterLink
                isDropDown
              >
                {getLocalizedText(POP_OUT_DIALOG_MESSAGE_LINK)}
              </UnderlineLink>
            ),
          },
        })}
      </h2>
      <div className={css.buttonContainer}>
        <PopOutButton
          width={buttonDimensions.width}
          height={buttonDimensions.height}
          onClick={closeDialog}
          dataTestId="popoutPlayerDialogButton"
        />
      </div>
    </CommonDialog>
  );
}
